import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteGetExamRequestReports} from 'data/usecases/private/exam-results/remote-get-exam-request-reports';
import {GetExamRequestReports} from 'domain/usecases/private/exam-results/get-exam-request-reports';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetExamRequestReports = (nuPedido: string): GetExamRequestReports => {
	const url = BookedFlowEndPoints.examRequestReports.replace(':nuPedido', nuPedido);

	return new RemoteGetExamRequestReports(makeBFFApiUrl(url), makeAuthorizeHttpClientDecorator());
};
